import React, { useState, useEffect } from 'react';
import { solicitudesAPI } from '../../services/api';

const InscripcionPublica = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [step, setStep] = useState(1);

  // Validación de cédula
  const [validandoCedula, setValidandoCedula] = useState(false);
  const [cedulaDuplicada, setCedulaDuplicada] = useState(false);
  const [cedulaDuplicadaTipo, setCedulaDuplicadaTipo] = useState('');

  // Validación de duplicado por nombre+fecha
  const [validandoDuplicado, setValidandoDuplicado] = useState(false);
  const [duplicadoPorNombre, setDuplicadoPorNombre] = useState(false);
  const [duplicadoPorNombreTipo, setDuplicadoPorNombreTipo] = useState('');

  // Archivos
  const [archivos, setArchivos] = useState({
    cedula_alumno: null,
    partida_nacimiento: null,
    cedula_representante: null,
  });

  const [formData, setFormData] = useState({
    // Datos del alumno
    apellidos: '', nombres: '', cedula: '', tiene_cedula_propia: false, sexo: '',
    fecha_nacimiento: '', lugar_nacimiento: '', estado_nacimiento: '', pais: 'Venezuela',
    telefono_celular: '', direccion_habitacion: '', colegio_actual: '',
    tiene_uniforme: false, numero_dorsal: '',

    // Datos del padre
    padre_nombre: '', padre_apellido: '', padre_cedula: '', padre_email: '', padre_telefono: '',
    padre_empresa: '', padre_cargo: '', padre_direccion_trabajo: '', padre_telefono_trabajo: '',
    padre_telefono_oficina: '',

    // Datos de la madre
    madre_nombre: '', madre_apellido: '', madre_cedula: '', madre_email: '', madre_telefono: '',
    madre_empresa: '', madre_cargo: '', madre_direccion_trabajo: '', madre_telefono_trabajo: '',
    madre_telefono_oficina: '',

    representante_principal: '',

    // Datos médicos
    tiene_seguro: false, compania_seguro: '', numero_poliza: '',
    padece_enfermedades: false, tipo_enfermedades: '', alergias: '', tipo_sangre: '', grupo_sangre: '',

    // Contactos de emergencia
    emergencia1_nombre: '', emergencia1_parentesco: '', emergencia1_cedula: '', emergencia1_telefono: '',
    emergencia2_nombre: '', emergencia2_parentesco: '', emergencia2_cedula: '', emergencia2_telefono: '',

    // Medicamentos
    medicamento_alergia: '', dosis_alergia: '', medicamento_dolor_cabeza: '', dosis_dolor_cabeza: '',

    // Autorizaciones
    autorizacion_medica: false, autorizacion_imagen: false, autorizacion_medicamentos: false
  });

  // Validar cédula en tiempo real
  useEffect(() => {
    const validarCedulaEnTiempoReal = async () => {
      if (formData.tiene_cedula_propia && formData.cedula && formData.cedula.length >= 7) {
        setValidandoCedula(true);
        try {
          const response = await solicitudesAPI.verificarCedula(formData.cedula.toUpperCase());
          setCedulaDuplicada(response.data.duplicada);
          setCedulaDuplicadaTipo(response.data.tipo || '');
        } catch (error) {
          console.error('Error validando cédula:', error);
        } finally {
          setValidandoCedula(false);
        }
      } else {
        setCedulaDuplicada(false);
        setCedulaDuplicadaTipo('');
      }
    };

    const timeoutId = setTimeout(validarCedulaEnTiempoReal, 500);
    return () => clearTimeout(timeoutId);
  }, [formData.cedula, formData.tiene_cedula_propia]);

  // Validar duplicado por nombre+apellido+fecha en tiempo real
  useEffect(() => {
    const validarDuplicadoEnTiempoReal = async () => {
      const nombres = formData.nombres.trim();
      const apellidos = formData.apellidos.trim();
      const fecha = formData.fecha_nacimiento;

      if (nombres.length >= 2 && apellidos.length >= 2 && fecha) {
        setValidandoDuplicado(true);
        try {
          const response = await solicitudesAPI.verificarDuplicado(nombres, apellidos, fecha);
          setDuplicadoPorNombre(response.data.duplicada);
          setDuplicadoPorNombreTipo(response.data.tipo || '');
        } catch (error) {
          console.error('Error validando duplicado:', error);
        } finally {
          setValidandoDuplicado(false);
        }
      } else {
        setDuplicadoPorNombre(false);
        setDuplicadoPorNombreTipo('');
      }
    };

    const timeoutId = setTimeout(validarDuplicadoEnTiempoReal, 500);
    return () => clearTimeout(timeoutId);
  }, [formData.nombres, formData.apellidos, formData.fecha_nacimiento]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let finalValue = type === 'checkbox' ? checked : value;

    // Convertir a mayúsculas excepto emails
    if (type === 'text' || type === 'textarea') {
      if (!name.includes('email')) {
        finalValue = value.toUpperCase();
      }
    }

    setFormData({ ...formData, [name]: finalValue });
  };

  const calcularCategoria = (fechaNacimiento) => {
    if (!fechaNacimiento) return null;
    const currentYear = new Date().getFullYear();
    const birthYear = new Date(fechaNacimiento).getFullYear();
    const edadAlFinalDelAno = currentYear - birthYear;
    if (edadAlFinalDelAno < 8) return 'Pre-infantil';
    if (edadAlFinalDelAno <= 9) return 'Sub-10';
    if (edadAlFinalDelAno <= 11) return 'Sub-12';
    if (edadAlFinalDelAno <= 13) return 'Sub-14';
    if (edadAlFinalDelAno <= 15) return 'Sub-16';
    if (edadAlFinalDelAno <= 17) return 'Sub-18';
    return 'Mayor';
  };

  const validarCedulaFormato = (cedula) => {
    return /^[VEJ][0-9]{6,9}$/i.test(cedula);
  };

  const validarEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const validateStep = (stepNumber) => {
    setError('');

    switch (stepNumber) {
      case 1:
        if (!formData.nombres.trim() || !formData.apellidos.trim()) {
          setError('Nombre y apellidos son requeridos');
          return false;
        }
        if (!formData.fecha_nacimiento || !formData.sexo) {
          setError('Fecha de nacimiento y sexo son requeridos');
          return false;
        }
        if (formData.tiene_cedula_propia && !validarCedulaFormato(formData.cedula)) {
          setError('Formato de cédula inválido (Ej: V12345678)');
          return false;
        }
        if (cedulaDuplicada) {
          setError(cedulaDuplicadaTipo === 'solicitud'
            ? 'Ya existe una solicitud pendiente con esta cédula'
            : 'Esta cédula ya está registrada como jugador');
          return false;
        }
        if (duplicadoPorNombre) {
          setError(duplicadoPorNombreTipo === 'solicitud'
            ? 'Ya existe una solicitud pendiente con este nombre y fecha de nacimiento'
            : 'Ya existe un jugador registrado con este nombre y fecha de nacimiento');
          return false;
        }
        break;

      case 2:
        if (!formData.padre_nombre && !formData.madre_nombre) {
          setError('Debe ingresar datos de al menos un representante');
          return false;
        }
        if (formData.padre_nombre && !validarCedulaFormato(formData.padre_cedula)) {
          setError('Cédula del padre inválida');
          return false;
        }
        if (formData.madre_nombre && !validarCedulaFormato(formData.madre_cedula)) {
          setError('Cédula de la madre inválida');
          return false;
        }
        if (formData.padre_email && !validarEmail(formData.padre_email)) {
          setError('Email del padre inválido');
          return false;
        }
        if (formData.madre_email && !validarEmail(formData.madre_email)) {
          setError('Email de la madre inválido');
          return false;
        }
        if (formData.padre_email && formData.madre_email && !formData.representante_principal) {
          setError('Debe seleccionar el representante principal');
          return false;
        }
        break;

      case 4:
        if (!formData.emergencia1_nombre || !formData.emergencia1_telefono) {
          setError('Debe agregar al menos un contacto de emergencia');
          return false;
        }
        break;

      case 5:
        if (!formData.autorizacion_medica || !formData.autorizacion_imagen) {
          setError('Debe aceptar las autorizaciones obligatorias');
          return false;
        }
        // Validate mandatory documents
        if (formData.tiene_cedula_propia && !archivos.cedula_alumno) {
          setError('Debe adjuntar la copia de la cédula del alumno');
          return false;
        }
        if (!formData.tiene_cedula_propia && !archivos.partida_nacimiento) {
          setError('Debe adjuntar la copia de la partida de nacimiento');
          return false;
        }
        if (!archivos.cedula_representante) {
          setError('Debe adjuntar la copia de la cédula del representante');
          return false;
        }
        break;

      default:
        break;
    }

    return true;
  };

  const nextStep = () => {
    if (validateStep(step)) {
      setStep(step + 1);
      window.scrollTo(0, 0);
    }
  };

  const prevStep = () => {
    setStep(step - 1);
    window.scrollTo(0, 0);
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files[0]) {
      const file = files[0];
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        setError('El archivo no debe superar los 5MB');
        e.target.value = '';
        return;
      }
      // Aceptar cualquier tipo de imagen (cámaras de celular pueden enviar heic, heif, etc.)
      const esImagen = file.type.startsWith('image/');
      const esPDF = file.type === 'application/pdf';
      // Algunos celulares no envían type, validar por extensión como respaldo
      const extensionesValidas = ['.jpg', '.jpeg', '.png', '.webp', '.heic', '.heif', '.pdf'];
      const tieneExtensionValida = extensionesValidas.some(ext => file.name.toLowerCase().endsWith(ext));

      if (!esImagen && !esPDF && !tieneExtensionValida) {
        setError('Solo se permiten archivos de imagen o PDF');
        e.target.value = '';
        return;
      }
      setError('');
      setArchivos(prev => ({ ...prev, [name]: file }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateStep(5)) return;

    try {
      setLoading(true);
      setError('');

      const submitData = new FormData();

      // Agregar todos los campos del formulario
      Object.keys(formData).forEach(key => {
        submitData.append(key, formData[key]);
      });

      // Agregar archivos
      if (archivos.cedula_alumno) submitData.append('cedula_alumno', archivos.cedula_alumno);
      if (archivos.partida_nacimiento) submitData.append('partida_nacimiento', archivos.partida_nacimiento);
      if (archivos.cedula_representante) submitData.append('cedula_representante', archivos.cedula_representante);

      await solicitudesAPI.create(submitData);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al enviar la solicitud');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-600 to-green-600 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-2xl text-center">
          <div className="text-6xl mb-6">✅</div>
          <h1 className="text-3xl font-bold text-blue-600 mb-4">¡Solicitud Enviada!</h1>
          <p className="text-gray-700 mb-4">Tu solicitud de inscripción ha sido recibida exitosamente.</p>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-800 mb-2"><strong>Próximos pasos:</strong></p>
            <ul className="text-sm text-blue-700 text-left list-disc list-inside space-y-1">
              <li>Revisaremos tu solicitud en 24-48 horas</li>
              <li>Te contactaremos para solicitar documentos si es necesario</li>
              <li>Una vez aprobado, recibirás las credenciales de acceso</li>
            </ul>
          </div>
          <p className="text-gray-500 text-sm mt-4">Los Salias FC - Escuela de Fútbol</p>
        </div>
      </div>
    );
  }

  const renderStep1 = () => (
    <div className="space-y-6">
      <h3 className="text-2xl font-bold text-blue-600 mb-4">📋 Datos del Alumno</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Apellidos *</label>
          <input type="text" name="apellidos" value={formData.apellidos} onChange={handleChange}
            className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Nombres *</label>
          <input type="text" name="nombres" value={formData.nombres} onChange={handleChange}
            className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
        </div>

        <div className="md:col-span-2">
          <label className="flex items-center mb-3">
            <input type="checkbox" name="tiene_cedula_propia" checked={formData.tiene_cedula_propia}
              onChange={handleChange} className="mr-2 h-5 w-5" />
            <span className="text-sm font-medium text-gray-700">¿El alumno tiene cédula propia?</span>
          </label>

          {formData.tiene_cedula_propia && (
            <div>
              <input type="text" name="cedula" value={formData.cedula} onChange={handleChange}
                placeholder="V12345678"
                className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none ${
                  cedulaDuplicada ? 'border-red-500' : validandoCedula ? 'border-yellow-500' : 'border-gray-300 focus:border-blue-500'
                }`} />

              {validandoCedula && (
                <p className="mt-2 text-sm text-yellow-600">⏳ Verificando cédula...</p>
              )}

              {cedulaDuplicada && (
                <div className="mt-2 bg-red-50 border border-red-300 rounded-lg p-3">
                  <p className="text-sm text-red-700">
                    {cedulaDuplicadaTipo === 'solicitud'
                      ? '⚠️ Ya existe una solicitud pendiente con esta cédula.'
                      : '⚠️ Esta cédula ya está registrada como jugador.'}
                  </p>
                </div>
              )}

              {!cedulaDuplicada && formData.cedula && validarCedulaFormato(formData.cedula) && !validandoCedula && (
                <p className="mt-2 text-sm text-green-600">✅ Cédula disponible</p>
              )}
            </div>
          )}

          {!formData.tiene_cedula_propia && (
            <p className="text-sm text-gray-500 bg-blue-50 border border-blue-200 rounded-lg p-3">
              ℹ️ Se generará una cédula automáticamente basada en la cédula del representante
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Sexo *</label>
          <select name="sexo" value={formData.sexo} onChange={handleChange}
            className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none">
            <option value="">Seleccione...</option>
            <option value="M">Masculino</option>
            <option value="F">Femenino</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Fecha de Nacimiento *</label>
          <input type="date" name="fecha_nacimiento" value={formData.fecha_nacimiento} onChange={handleChange}
            className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none ${
              duplicadoPorNombre ? 'border-red-500' : 'border-gray-300 focus:border-blue-500'
            }`} />
        </div>

        {formData.fecha_nacimiento && (
          <div className="md:col-span-2">
            <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-3 flex items-center gap-3">
              <span className="text-lg">⚽</span>
              <div>
                <span className="text-sm text-indigo-700">Categoria: </span>
                <span className="font-bold text-indigo-800">{calcularCategoria(formData.fecha_nacimiento)}</span>
              </div>
            </div>
          </div>
        )}

        {validandoDuplicado && (
          <div className="md:col-span-2">
            <p className="text-sm text-yellow-600">⏳ Verificando si el jugador ya está registrado...</p>
          </div>
        )}

        {duplicadoPorNombre && !validandoDuplicado && (
          <div className="md:col-span-2">
            <div className="bg-red-50 border border-red-300 rounded-lg p-3">
              <p className="text-sm text-red-700">
                {duplicadoPorNombreTipo === 'solicitud'
                  ? '⚠️ Ya existe una solicitud pendiente con este nombre y fecha de nacimiento.'
                  : '⚠️ Ya existe un jugador registrado con este nombre y fecha de nacimiento.'}
              </p>
            </div>
          </div>
        )}

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Lugar de Nacimiento</label>
          <input type="text" name="lugar_nacimiento" value={formData.lugar_nacimiento} onChange={handleChange}
            className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Estado</label>
          <input type="text" name="estado_nacimiento" value={formData.estado_nacimiento} onChange={handleChange}
            className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Teléfono Celular</label>
          <input type="tel" name="telefono_celular" value={formData.telefono_celular} onChange={handleChange}
            placeholder="04141234567"
            className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Colegio donde estudia</label>
          <input type="text" name="colegio_actual" value={formData.colegio_actual} onChange={handleChange}
            className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">Dirección</label>
          <textarea name="direccion_habitacion" value={formData.direccion_habitacion} onChange={handleChange}
            rows="2" className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
        </div>

        <div className="md:col-span-2">
          <label className="flex items-center mb-3">
            <input type="checkbox" name="tiene_uniforme" checked={formData.tiene_uniforme}
              onChange={handleChange} className="mr-2 h-5 w-5" />
            <span className="text-sm font-medium text-gray-700">¿El alumno tiene uniforme actualmente?</span>
          </label>

          {formData.tiene_uniforme && (
            <div className="ml-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">Número de Dorsal</label>
              <input type="text" name="numero_dorsal" value={formData.numero_dorsal} onChange={handleChange}
                placeholder="Ej: 10"
                className="w-full md:w-1/4 px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderStep2 = () => (
    <div className="space-y-6">
      <h3 className="text-2xl font-bold text-blue-600 mb-4">👨‍👦 Datos de los Representantes</h3>

      {/* PADRE */}
      <div className="bg-blue-50 rounded-xl p-6">
        <h4 className="text-lg font-bold text-blue-600 mb-4">👨 Datos del Padre</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Nombre</label>
            <input type="text" name="padre_nombre" value={formData.padre_nombre} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Apellido</label>
            <input type="text" name="padre_apellido" value={formData.padre_apellido} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Cédula</label>
            <input type="text" name="padre_cedula" value={formData.padre_cedula} onChange={handleChange}
              placeholder="V12345678"
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
            <input type="email" name="padre_email" value={formData.padre_email} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Teléfono</label>
            <input type="tel" name="padre_telefono" value={formData.padre_telefono} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Empresa</label>
            <input type="text" name="padre_empresa" value={formData.padre_empresa} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Teléfono Oficina</label>
            <input type="tel" name="padre_telefono_oficina" value={formData.padre_telefono_oficina} onChange={handleChange}
              placeholder="02121234567"
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
          </div>
        </div>
      </div>

      {/* MADRE */}
      <div className="bg-pink-50 rounded-xl p-6">
        <h4 className="text-lg font-bold text-pink-600 mb-4">👩 Datos de la Madre</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Nombre</label>
            <input type="text" name="madre_nombre" value={formData.madre_nombre} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-pink-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Apellido</label>
            <input type="text" name="madre_apellido" value={formData.madre_apellido} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-pink-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Cédula</label>
            <input type="text" name="madre_cedula" value={formData.madre_cedula} onChange={handleChange}
              placeholder="V12345678"
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-pink-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
            <input type="email" name="madre_email" value={formData.madre_email} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-pink-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Teléfono</label>
            <input type="tel" name="madre_telefono" value={formData.madre_telefono} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-pink-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Empresa</label>
            <input type="text" name="madre_empresa" value={formData.madre_empresa} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-pink-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Teléfono Oficina</label>
            <input type="tel" name="madre_telefono_oficina" value={formData.madre_telefono_oficina} onChange={handleChange}
              placeholder="02121234567"
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-pink-500 focus:outline-none" />
          </div>
        </div>
      </div>

      {/* Selección representante principal */}
      {formData.padre_email && formData.madre_email && (
        <div className="bg-yellow-50 border-2 border-yellow-400 rounded-xl p-6">
          <h4 className="text-lg font-bold text-yellow-800 mb-3">👤 Representante Principal *</h4>
          <p className="text-sm text-yellow-700 mb-4">
            Seleccione quién recibirá las credenciales de acceso al sistema:
          </p>
          <div className="space-y-2">
            <label className="flex items-center p-3 border-2 border-yellow-300 rounded-lg cursor-pointer hover:bg-yellow-100">
              <input type="radio" name="representante_principal" value="padre"
                checked={formData.representante_principal === 'padre'} onChange={handleChange}
                className="mr-3 h-5 w-5" />
              <span className="font-medium">Padre - {formData.padre_email}</span>
            </label>
            <label className="flex items-center p-3 border-2 border-yellow-300 rounded-lg cursor-pointer hover:bg-yellow-100">
              <input type="radio" name="representante_principal" value="madre"
                checked={formData.representante_principal === 'madre'} onChange={handleChange}
                className="mr-3 h-5 w-5" />
              <span className="font-medium">Madre - {formData.madre_email}</span>
            </label>
          </div>
        </div>
      )}
    </div>
  );

  const renderStep3 = () => (
    <div className="space-y-6">
      <h3 className="text-2xl font-bold text-blue-600 mb-4">🏥 Información Médica</h3>

      <div className="bg-gray-50 rounded-xl p-6">
        <label className="flex items-center mb-4">
          <input type="checkbox" name="tiene_seguro" checked={formData.tiene_seguro} onChange={handleChange}
            className="mr-2 h-5 w-5" />
          <span className="text-sm font-medium text-gray-700">¿Tiene póliza de seguro?</span>
        </label>

        {formData.tiene_seguro && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ml-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Compañía</label>
              <input type="text" name="compania_seguro" value={formData.compania_seguro} onChange={handleChange}
                className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Nro. Póliza</label>
              <input type="text" name="numero_poliza" value={formData.numero_poliza} onChange={handleChange}
                className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
            </div>
          </div>
        )}
      </div>

      <div className="bg-gray-50 rounded-xl p-6">
        <label className="flex items-center mb-4">
          <input type="checkbox" name="padece_enfermedades" checked={formData.padece_enfermedades} onChange={handleChange}
            className="mr-2 h-5 w-5" />
          <span className="text-sm font-medium text-gray-700">¿Padece o ha padecido alguna enfermedad importante?</span>
        </label>

        {formData.padece_enfermedades && (
          <div className="ml-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Enfermedad</label>
            <textarea name="tipo_enfermedades" value={formData.tipo_enfermedades} onChange={handleChange}
              rows="3" className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
          </div>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">¿El alumno es alérgico a?</label>
        <textarea name="alergias" value={formData.alergias} onChange={handleChange}
          placeholder="MEDICAMENTOS, ALIMENTOS, PICADURAS, ETC." rows="2"
          className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Sangre</label>
          <select name="tipo_sangre" value={formData.tipo_sangre} onChange={handleChange}
            className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none">
            <option value="">Seleccione...</option>
            <option value="A">A</option>
            <option value="B">B</option>
            <option value="AB">AB</option>
            <option value="O">O</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Grupo Sanguíneo</label>
          <select name="grupo_sangre" value={formData.grupo_sangre} onChange={handleChange}
            className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none">
            <option value="">Seleccione...</option>
            <option value="+">Positivo (+)</option>
            <option value="-">Negativo (-)</option>
          </select>
        </div>
      </div>
    </div>
  );

  const renderStep4 = () => (
    <div className="space-y-6">
      <h3 className="text-2xl font-bold text-blue-600 mb-4">🆘 Contactos de Emergencia</h3>

      {/* Contacto 1 */}
      <div className="bg-red-50 rounded-xl p-6">
        <h4 className="text-lg font-bold text-red-600 mb-4">Persona 1 *</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Nombre y Apellido *</label>
            <input type="text" name="emergencia1_nombre" value={formData.emergencia1_nombre} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-red-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Parentesco</label>
            <select name="emergencia1_parentesco" value={formData.emergencia1_parentesco} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-red-500 focus:outline-none">
              <option value="">Seleccione...</option>
              <option value="PADRE">Padre</option>
              <option value="MADRE">Madre</option>
              <option value="TIO">Tío/a</option>
              <option value="ABUELO">Abuelo/a</option>
              <option value="HERMANO">Hermano/a</option>
              <option value="OTRO">Otro</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Cédula</label>
            <input type="text" name="emergencia1_cedula" value={formData.emergencia1_cedula} onChange={handleChange}
              placeholder="V12345678"
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-red-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Teléfono *</label>
            <input type="tel" name="emergencia1_telefono" value={formData.emergencia1_telefono} onChange={handleChange}
              placeholder="04141234567"
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-red-500 focus:outline-none" />
          </div>
        </div>
      </div>

      {/* Contacto 2 */}
      <div className="bg-gray-50 rounded-xl p-6">
        <h4 className="text-lg font-bold text-gray-600 mb-4">Persona 2 (Opcional)</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Nombre y Apellido</label>
            <input type="text" name="emergencia2_nombre" value={formData.emergencia2_nombre} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-gray-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Parentesco</label>
            <select name="emergencia2_parentesco" value={formData.emergencia2_parentesco} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-gray-500 focus:outline-none">
              <option value="">Seleccione...</option>
              <option value="PADRE">Padre</option>
              <option value="MADRE">Madre</option>
              <option value="TIO">Tío/a</option>
              <option value="ABUELO">Abuelo/a</option>
              <option value="HERMANO">Hermano/a</option>
              <option value="OTRO">Otro</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Cédula</label>
            <input type="text" name="emergencia2_cedula" value={formData.emergencia2_cedula} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-gray-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Teléfono</label>
            <input type="tel" name="emergencia2_telefono" value={formData.emergencia2_telefono} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-gray-500 focus:outline-none" />
          </div>
        </div>
      </div>

      {/* Medicamentos */}
      <div className="bg-blue-50 rounded-xl p-6">
        <h4 className="text-lg font-bold text-blue-600 mb-4">💊 Medicamentos Autorizados (Opcional)</h4>
        <p className="text-sm text-blue-700 mb-4">En caso de que el representante NO se encuentre presente</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Medicamento para alergia</label>
            <input type="text" name="medicamento_alergia" value={formData.medicamento_alergia} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Dosis</label>
            <input type="text" name="dosis_alergia" value={formData.dosis_alergia} onChange={handleChange}
              placeholder="Ej: 1 tableta de 10mg"
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Medicamento para dolor de cabeza</label>
            <input type="text" name="medicamento_dolor_cabeza" value={formData.medicamento_dolor_cabeza} onChange={handleChange}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Dosis</label>
            <input type="text" name="dosis_dolor_cabeza" value={formData.dosis_dolor_cabeza} onChange={handleChange}
              placeholder="Ej: 1 tableta de 500mg"
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none" />
          </div>
        </div>
      </div>
    </div>
  );

  const renderStep5 = () => (
    <div className="space-y-6">
      <h3 className="text-2xl font-bold text-blue-600 mb-4">✅ Autorizaciones</h3>

      <div className="bg-yellow-50 border border-yellow-300 rounded-lg p-4 mb-6">
        <p className="text-sm text-yellow-800">⚠️ Por favor lea cuidadosamente cada autorización antes de aceptar</p>
      </div>

      {/* Autorización Médica */}
      <div className="bg-white border-2 border-blue-500 rounded-xl p-6">
        <h4 className="font-bold text-gray-900 mb-3">🏥 Autorización de Atención Médica de Emergencia</h4>
        <p className="text-sm text-gray-700 mb-4">
          Autorizo a los representantes del cuerpo técnico y/o directivo de LOS SALIAS FC, que en caso de que mi
          representado sufra algún accidente dentro del horario de actividades, lo trasladen al centro de salud más
          cercano para brindar la atención médica primaria, quedando la academia limitada y exonerada de cualquier
          responsabilidad de índole civil, económica o penal.
        </p>
        <label className="flex items-center">
          <input type="checkbox" name="autorizacion_medica" checked={formData.autorizacion_medica}
            onChange={handleChange} className="mr-3 h-5 w-5" />
          <span className="text-sm font-medium text-gray-900">Acepto la autorización médica *</span>
        </label>
      </div>

      {/* Autorización de Imagen */}
      <div className="bg-white border-2 border-green-500 rounded-xl p-6">
        <h4 className="font-bold text-gray-900 mb-3">📸 Autorización de Uso de Imagen</h4>
        <p className="text-sm text-gray-700 mb-4">
          Autorizo el uso de la imagen de mi representado en registros fotográficos y audiovisuales para difusión
          en redes sociales y medios de comunicación, quedando exonerado LOS SALIAS FC de cualquier responsabilidad.
        </p>
        <label className="flex items-center">
          <input type="checkbox" name="autorizacion_imagen" checked={formData.autorizacion_imagen}
            onChange={handleChange} className="mr-3 h-5 w-5" />
          <span className="text-sm font-medium text-gray-900">Acepto la autorización de imagen *</span>
        </label>
      </div>

      {/* Autorización de Medicamentos */}
      <div className="bg-white border-2 border-purple-500 rounded-xl p-6">
        <h4 className="font-bold text-gray-900 mb-3">💊 Autorización de Suministro de Medicamentos</h4>
        <p className="text-sm text-gray-700 mb-4">
          Autorizo el suministro de los medicamentos indicados en caso de emergencia, siempre que yo NO me encuentre
          presente, limitando y exonerando a la academia de cualquier responsabilidad.
        </p>
        <label className="flex items-center">
          <input type="checkbox" name="autorizacion_medicamentos" checked={formData.autorizacion_medicamentos}
            onChange={handleChange} className="mr-3 h-5 w-5" />
          <span className="text-sm font-medium text-gray-900">Acepto la autorización de medicamentos (Opcional)</span>
        </label>
      </div>

      {/* Documentos */}
      <h3 className="text-2xl font-bold text-blue-600 mb-4 mt-8">📄 Documentos</h3>

      <div className="bg-yellow-50 border border-yellow-300 rounded-lg p-4 mb-4">
        <p className="text-sm text-yellow-800">📎 <strong>Los documentos son obligatorios.</strong> Puede tomar una foto con la cámara o seleccionar un archivo. Formatos: JPG, PNG, WEBP o PDF. Máximo: 5MB.</p>
      </div>

      {formData.tiene_cedula_propia ? (
        <div className={`bg-white border-2 ${archivos.cedula_alumno ? 'border-green-500' : 'border-red-300'} rounded-xl p-6`}>
          <h4 className="font-bold text-gray-900 mb-3">🪪 Copia de Cédula del Alumno *</h4>
          {archivos.cedula_alumno ? (
            <div className="bg-green-50 border border-green-300 rounded-lg p-4">
              <div className="flex items-center gap-3 mb-3">
                <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold">✓</div>
                <div>
                  <p className="font-semibold text-green-800">Foto guardada correctamente</p>
                  <p className="text-sm text-green-600">{archivos.cedula_alumno.name} ({(archivos.cedula_alumno.size / 1024).toFixed(0)} KB)</p>
                </div>
              </div>
              {archivos.cedula_alumno.type?.startsWith('image/') && (
                <img src={URL.createObjectURL(archivos.cedula_alumno)} alt="Vista previa"
                  className="w-full max-h-48 object-contain rounded-lg mb-3 border" />
              )}
              <button type="button" onClick={() => setArchivos(prev => ({ ...prev, cedula_alumno: null }))}
                className="text-sm text-red-600 hover:text-red-800 font-medium">
                ✕ Eliminar y tomar otra foto
              </button>
            </div>
          ) : (
            <div className="flex flex-col sm:flex-row gap-3">
              <label className="flex-1 cursor-pointer">
                <div className="flex items-center justify-center gap-2 py-3 px-4 bg-blue-50 text-blue-700 rounded-lg border-2 border-dashed border-blue-300 hover:bg-blue-100 transition-all">
                  <span>📷 Tomar Foto</span>
                </div>
                <input type="file" name="cedula_alumno" onChange={handleFileChange}
                  accept="image/*" capture="environment" className="hidden" />
              </label>
              <label className="flex-1 cursor-pointer">
                <div className="flex items-center justify-center gap-2 py-3 px-4 bg-gray-50 text-gray-700 rounded-lg border-2 border-dashed border-gray-300 hover:bg-gray-100 transition-all">
                  <span>📁 Seleccionar Archivo</span>
                </div>
                <input type="file" name="cedula_alumno" onChange={handleFileChange}
                  accept="image/jpeg,image/png,image/webp,application/pdf" className="hidden" />
              </label>
            </div>
          )}
        </div>
      ) : (
        <div className={`bg-white border-2 ${archivos.partida_nacimiento ? 'border-green-500' : 'border-red-300'} rounded-xl p-6`}>
          <h4 className="font-bold text-gray-900 mb-3">📜 Copia de Partida de Nacimiento *</h4>
          <p className="text-sm text-gray-500 mb-3">Como el alumno no tiene cédula propia, debe adjuntar la partida de nacimiento.</p>
          {archivos.partida_nacimiento ? (
            <div className="bg-green-50 border border-green-300 rounded-lg p-4">
              <div className="flex items-center gap-3 mb-3">
                <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold">✓</div>
                <div>
                  <p className="font-semibold text-green-800">Foto guardada correctamente</p>
                  <p className="text-sm text-green-600">{archivos.partida_nacimiento.name} ({(archivos.partida_nacimiento.size / 1024).toFixed(0)} KB)</p>
                </div>
              </div>
              {archivos.partida_nacimiento.type?.startsWith('image/') && (
                <img src={URL.createObjectURL(archivos.partida_nacimiento)} alt="Vista previa"
                  className="w-full max-h-48 object-contain rounded-lg mb-3 border" />
              )}
              <button type="button" onClick={() => setArchivos(prev => ({ ...prev, partida_nacimiento: null }))}
                className="text-sm text-red-600 hover:text-red-800 font-medium">
                ✕ Eliminar y tomar otra foto
              </button>
            </div>
          ) : (
            <div className="flex flex-col sm:flex-row gap-3">
              <label className="flex-1 cursor-pointer">
                <div className="flex items-center justify-center gap-2 py-3 px-4 bg-blue-50 text-blue-700 rounded-lg border-2 border-dashed border-blue-300 hover:bg-blue-100 transition-all">
                  <span>📷 Tomar Foto</span>
                </div>
                <input type="file" name="partida_nacimiento" onChange={handleFileChange}
                  accept="image/*" capture="environment" className="hidden" />
              </label>
              <label className="flex-1 cursor-pointer">
                <div className="flex items-center justify-center gap-2 py-3 px-4 bg-gray-50 text-gray-700 rounded-lg border-2 border-dashed border-gray-300 hover:bg-gray-100 transition-all">
                  <span>📁 Seleccionar Archivo</span>
                </div>
                <input type="file" name="partida_nacimiento" onChange={handleFileChange}
                  accept="image/jpeg,image/png,image/webp,application/pdf" className="hidden" />
              </label>
            </div>
          )}
        </div>
      )}

      <div className={`bg-white border-2 ${archivos.cedula_representante ? 'border-green-500' : 'border-red-300'} rounded-xl p-6 mt-4`}>
        <h4 className="font-bold text-gray-900 mb-3">🪪 Copia de Cédula del Representante *</h4>
        {archivos.cedula_representante ? (
          <div className="bg-green-50 border border-green-300 rounded-lg p-4">
            <div className="flex items-center gap-3 mb-3">
              <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold">✓</div>
              <div>
                <p className="font-semibold text-green-800">Foto guardada correctamente</p>
                <p className="text-sm text-green-600">{archivos.cedula_representante.name} ({(archivos.cedula_representante.size / 1024).toFixed(0)} KB)</p>
              </div>
            </div>
            {archivos.cedula_representante.type?.startsWith('image/') && (
              <img src={URL.createObjectURL(archivos.cedula_representante)} alt="Vista previa"
                className="w-full max-h-48 object-contain rounded-lg mb-3 border" />
            )}
            <button type="button" onClick={() => setArchivos(prev => ({ ...prev, cedula_representante: null }))}
              className="text-sm text-red-600 hover:text-red-800 font-medium">
              ✕ Eliminar y tomar otra foto
            </button>
          </div>
        ) : (
          <div className="flex flex-col sm:flex-row gap-3">
            <label className="flex-1 cursor-pointer">
              <div className="flex items-center justify-center gap-2 py-3 px-4 bg-blue-50 text-blue-700 rounded-lg border-2 border-dashed border-blue-300 hover:bg-blue-100 transition-all">
                <span>📷 Tomar Foto</span>
              </div>
              <input type="file" name="cedula_representante" onChange={handleFileChange}
                accept="image/*" capture="environment" className="hidden" />
            </label>
            <label className="flex-1 cursor-pointer">
              <div className="flex items-center justify-center gap-2 py-3 px-4 bg-gray-50 text-gray-700 rounded-lg border-2 border-dashed border-gray-300 hover:bg-gray-100 transition-all">
                <span>📁 Seleccionar Archivo</span>
              </div>
              <input type="file" name="cedula_representante" onChange={handleFileChange}
                accept="image/jpeg,image/png,image/webp,application/pdf" className="hidden" />
            </label>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 to-green-600 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-2xl shadow-2xl p-6 mb-6 text-center">
          <img src="/logo_lsfc.png" alt="Los Salias FC" className="w-24 h-24 mx-auto mb-4 object-contain" />
          <h1 className="text-3xl font-bold text-blue-600 mb-2">Inscripción Los Salias FC</h1>
          <p className="text-gray-600">Escuela de Fútbol</p>
        </div>

        {/* Progress Bar */}
        <div className="bg-white rounded-xl shadow-lg p-4 mb-6">
          <div className="flex justify-between mb-2 text-xs md:text-sm">
            {['Alumno', 'Representantes', 'Salud', 'Emergencias', 'Autorizaciones'].map((label, idx) => (
              <div key={idx} className={`${step === idx + 1 ? 'text-blue-600 font-bold' : step > idx + 1 ? 'text-green-600' : 'text-gray-400'}`}>
                {label}
              </div>
            ))}
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div className="bg-gradient-to-r from-blue-600 to-green-600 h-2 rounded-full transition-all"
              style={{ width: `${(step / 5) * 100}%` }} />
          </div>
          <p className="text-center text-sm text-gray-600 mt-2">Paso {step} de 5</p>
        </div>

        {/* Error */}
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg mb-6">
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="bg-white rounded-2xl shadow-2xl p-6 md:p-8">
            {step === 1 && renderStep1()}
            {step === 2 && renderStep2()}
            {step === 3 && renderStep3()}
            {step === 4 && renderStep4()}
            {step === 5 && renderStep5()}
          </div>

          {/* Navigation Buttons */}
          <div className="flex justify-between mt-6">
            {step > 1 && (
              <button type="button" onClick={prevStep}
                className="px-6 py-3 bg-white text-gray-700 rounded-lg shadow hover:shadow-lg">
                ← Anterior
              </button>
            )}
            {step < 5 ? (
              <button type="button" onClick={nextStep}
                className="px-6 py-3 ml-auto bg-gradient-to-r from-blue-600 to-green-600 text-white rounded-lg shadow-lg hover:shadow-xl">
                Siguiente →
              </button>
            ) : (
              <button type="submit" disabled={loading}
                className="px-6 py-3 ml-auto bg-gradient-to-r from-green-600 to-blue-600 text-white rounded-lg shadow-lg hover:shadow-xl disabled:opacity-50">
                {loading ? 'Enviando...' : '✅ Enviar Solicitud'}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default InscripcionPublica;
